// Port of Plunk.Reporting/TitleResolver.cs.
//
// The upstream `product_location_stats` table has a known data-quality
// issue where the `title` field can leak across products inside a
// session (an event captured on product A's page may carry product B's
// title). The `link` field stays correct, so we prefer the link-derived
// slug for display and fall back to the recorded title only when the
// link is missing or doesn't follow the expected pattern.

const LINK_PATTERN = /\/Product\/Detail\/[^/]+\/[^/]+\/([^/?#]+)/i;
export function resolveTitle(link, fallbackTitle) {
  if (!link || !String(link).trim()) return clean(fallbackTitle);
  const m = String(link).match(LINK_PATTERN);
  if (!m) return clean(fallbackTitle);
  let slug;
  try {
    slug = decodeURIComponent(m[1]);
  } catch (e) {
    slug = m[1];
  }
  // RS slug conventions: ~ → ", ! → /, - and _ → space
  const spaced = slug.replace(/~/g, '"').replace(/!/g, '/').replace(/-/g, ' ').replace(/_/g, ' ').trim().replace(/\s+/g, ' ');
  return spaced || clean(fallbackTitle);
}

// Collapse CSV-style quote escaping ("""""""Goya 94""""""" → "Goya 94")
// and trim surrounding quotes.
export function clean(s) {
  if (!s) return s || '';
  return String(s).replace(/"{2,}/g, '"').replace(/^"+|"+$/g, '');
}
export default {
  resolveTitle,
  clean
};